import { useContext } from 'react'
import { createPortal } from 'react-dom'
import type { LucideIcon } from 'lucide-react'
import { useOnline } from '@hooks/useOnline.ts'
import { FabSlotContext } from './AppShell.tsx'
import styles from './Fab.module.css'

type Props = {
	icon: LucideIcon
	label: string
	onClick: () => void
}

// Floating action button. Renders into the shell's bottom-right slot so
// every mini-app gets the same pinned, tab-bar-aware FAB without each
// re-deriving its position. Renders nothing until the slot is mounted.
// Disabled while offline, since every FAB starts a write.
export const Fab = ({ icon: Icon, label, onClick }: Props) => {
	const slot = useContext(FabSlotContext)
	const online = useOnline()
	if (!slot) return null
	return createPortal(
		<button
			type="button"
			className={styles.fab}
			onClick={onClick}
			disabled={!online}
		>
			<Icon size={20} aria-hidden="true" />
			{label}
		</button>,
		slot,
	)
}
